// ============================================================
//  CONFIG CLIENT — seul fichier à modifier par déploiement
// ============================================================

const config = {

  // --- IDENTITÉ ---
  clientName:  "Isolacier",     // ex: "Bazin"
  clientShort: "ISO",    // ex: "BZN" (sidebar repliée)

  // --- COULEURS ---
  primaryColor: "#e32636",  // ex: "#e32636"
  accentColor:  "#aeb6bc",   // ex: "#aeb6bc"

  // --- API ---
  apiBase: "https://isolacier.ams-crm.fr/api",            // ex: "https://bazin.ams-crm.fr/api"

  // --- AUTH ---
  // Clés utilisées dans localStorage
  tokenKey: "isolacier_token",          // ex: "authToken"
  userKey:  "isolacier_user",           // ex: "adminUser"
  // Champ login renvoyé par l'API dans data.user
  loginField: "username",      // ex: "username" ou "login"

  // --- ROUTE PAR DÉFAUT APRÈS LOGIN ---
  defaultRoute: "/planning",  // ex: "/planning"

  // --- APPS ---
  // Ajoute / supprime selon le client
  apps: [
    { key: "planning", label: "Planning", url: "https://planning.isolacier.ams-crm.fr" },
    { key: "kanban",   label: "Kanban",   url: "https://kanban.isolacier.ams-crm.fr"   },
  ]

};

export default config;
